export default __webpack_public_path__ + "static/media/pause.3ce5a6f3.svg";